import { Box, styled } from '@mui/material';
import React, { useMemo } from 'react';

interface TableCardProps {
  children: React.ReactNode;
  className?: string;
  size?: 'small' | 'medium' | 'large';
  enabledEffects?: boolean;
}

const StyledCard = styled(Box)<{ enabledEffects?: boolean }>(
  ({ enabledEffects }) => ({
    background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
    borderRadius: '16px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
    border: '1px solid rgba(15, 35, 223, 0.1)',
    transition: 'all 0.3s ease-in-out',
    ...(enabledEffects && {
      '&:hover': {
        boxShadow: '0 6px 20px rgba(15, 35, 223, 0.15)',
        transform: 'translateY(-2px)',
      },
    }),
  }),
);

const TableCard: React.FC<TableCardProps> = ({
  children,
  className,
  size = 'medium',
  enabledEffects = true,
}) => {
  const padding = useMemo(() => {
    if (size === 'small') return '12px';
    if (size === 'medium') return '24px';
    return '32px';
  }, [size]);

  return (
    <StyledCard
      className={className}
      sx={{ padding }}
      enabledEffects={enabledEffects}
    >
      {children}
    </StyledCard>
  );
};

export default TableCard;
